/* Northern Ridge Nursery - native warranty claim form (/pages/warranty-claim).
   Talks to the NRN plugin: POST {api}/lookup and POST {api}/claims (JSON, photos as base64 after in-browser resize).
   Markup: snippets/nrn-warranty-form.liquid. Styles: assets/nrn-pg-warranty-claim.css. */
(function () {
  'use strict';
  var root = document.querySelector('[data-nwf]');
  if (!root || root.__nwf) return;
  root.__nwf = true;

  var API = root.getAttribute('data-api');
  var form = root.querySelector('[data-nwf-form]');
  var q = function (s, el) { return (el || root).querySelector(s); };
  var qa = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var MAX_PHOTOS = 6, MAX_BYTES = 8 * 1024 * 1024, BUDGET = 7 * 1024 * 1024; // raw bytes; base64 adds ~33% and the server's JSON body cap is 10 MB
  var state = { mode: null, order: null, photos: [], whatTouched: false, busy: false };
  var track = function (n, d) { try { if (window.NRNTrack) window.NRNTrack(n, d || {}); } catch (e) {} };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var fmtDate = function (s) { var d = new Date(s); return isNaN(d) ? '' : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollTo = function (el) { if (el && el.scrollIntoView) el.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); };

  // ---------- prefill ----------
  try {
    var z = localStorage.getItem('nrn_zip');
    if (z && /^\d{5}$/.test(z)) q('#nwf-zip').value = z;
  } catch (e) {}
  var today = new Date(); today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
  q('#nwf-planted').max = today.toISOString().slice(0, 10);

  // "Is my plant covered?" helper above the form: copy its answer into "What happened?" until the shopper picks one here.
  function syncFromHelper() {
    if (state.whatTouched) return;
    var h = document.querySelector('input[name="wc-what"]:checked');
    if (!h) return;
    var r = q('input[name="what"][value="' + h.value + '"]');
    if (r) { r.checked = true; whatChanged(); }
  }
  document.addEventListener('change', function (e) { if (e.target && e.target.name === 'wc-what') syncFromHelper(); });

  // ---------- errors ----------
  var FIELDS = {
    order_number: ['#nwf-order', '#nwf-order-e'], email: ['#nwf-email', '#nwf-email-e'],
    items: [null, '#nwf-items-e'], what: ['input[name="what"]', '#nwf-what-e'],
    planting_date: ['#nwf-planted', '#nwf-planted-e'], zip: ['#nwf-zip', '#nwf-zip-e'],
    description: ['#nwf-desc', '#nwf-desc-e'], photos: ['#nwf-photos', '#nwf-photos-e'],
    name: ['#nwf-name', '#nwf-name-e'], consent: ['[data-nwf-consent]', '#nwf-consent-e'],
  };
  function fieldEl(k) {
    if (k === 'items') return q('[data-nwf-items] input[type=checkbox]') || q('[data-nwf-mrows] input');
    return FIELDS[k][0] ? q(FIELDS[k][0]) : null;
  }
  function setErr(k, msg) {
    var f = FIELDS[k]; if (!f) return;
    var e = q(f[1]); if (e) e.textContent = msg || '';
    var el = fieldEl(k);
    if (el && el.type !== 'radio' && el.type !== 'checkbox') { if (msg) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid'); }
  }
  function clearErrs() { Object.keys(FIELDS).forEach(function (k) { setErr(k, ''); }); q('[data-nwf-summary]').innerHTML = ''; }
  function showErrs(errs, lead) {
    var keys = Object.keys(errs); if (!keys.length) return;
    keys.forEach(function (k) { setErr(k, errs[k]); });
    var sum = q('[data-nwf-summary]');
    sum.innerHTML = '<b>' + esc(lead || 'Please fix ' + (keys.length === 1 ? 'this' : 'these ' + keys.length) + ' to send your claim:') + '</b><ul>'
      + keys.map(function (k) { var el = fieldEl(k); return '<li>' + (el && el.id ? '<a href="#' + el.id + '">' + esc(errs[k]) + '</a>' : esc(errs[k])) + '</li>'; }).join('') + '</ul>';
    sum.focus();
    scrollTo(sum);
  }
  q('[data-nwf-summary]').addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]'); if (!a) return;
    e.preventDefault(); var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) { t.focus(); scrollTo(t.closest('.nwf__f, .nwf__step') || t); }
  });

  function busy(btn, on) { state.busy = on; btn.disabled = on; btn.classList.toggle('is-busy', on); btn.setAttribute('aria-busy', on ? 'true' : 'false'); }

  function post(path, body) {
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, 60000);
    return fetch(API + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined, credentials: 'omit' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { clearTimeout(t); return { status: r.status, ok: r.ok, data: j }; }); })
      .catch(function () { clearTimeout(t); return { status: 0, ok: false, data: { error: "We couldn't reach the claim server. Check your connection and try again." } }; });
  }

  // ---------- step 1: lookup ----------
  var lookupBtn = q('[data-nwf-lookup]');
  var lookupStatus = q('[data-nwf-lookup-status]');
  function setLookupStatus(msg, ok) { lookupStatus.textContent = msg || ''; lookupStatus.className = 'nwf__status' + (msg ? (ok ? ' nwf__status--ok' : ' nwf__status--bad') : ''); }

  lookupBtn.addEventListener('click', function () {
    if (state.busy) return;
    clearErrs();
    var order = q('#nwf-order').value.trim(), email = q('#nwf-email').value.trim();
    var errs = {};
    if (!/^#?\s*(nrn)?\s*\d{4,7}$/i.test(order)) errs.order_number = 'Enter your order number, like NRN12345.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) errs.email = 'Enter the email you ordered with.';
    if (Object.keys(errs).length) return showErrs(errs);
    busy(lookupBtn, true); setLookupStatus('Looking up your order…', true);
    post('/lookup', { order_number: order, email: email }).then(function (r) {
      busy(lookupBtn, false);
      if (r.ok && r.data.ok) {
        state.order = r.data.order;
        var o = state.order;
        setLookupStatus('Found order ' + o.order_number + (o.order_date ? ' from ' + fmtDate(o.order_date) : '') + '. Pick the plants this claim is for.', true);
        if (o.ship_zip && !q('#nwf-zip').value) q('#nwf-zip').value = o.ship_zip;
        q('#nwf-order').value = o.order_number;
        showRest('order');
        track('warranty_lookup', { result: 'found' });
      } else {
        setLookupStatus((r.data && r.data.error) || "We couldn't find that order.", false);
        track('warranty_lookup', { result: 'not_found_' + r.status });
        showRest('manual', true);
      }
    });
  });
  q('[data-nwf-manual]').addEventListener('click', function () { setLookupStatus('No problem. Enter your plants by hand below. Add your order number above if you find it.', true); showRest('manual'); });
  ['#nwf-order', '#nwf-email'].forEach(function (s) {
    q(s).addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); lookupBtn.click(); } });
  });

  function showRest(mode, keepFocus) {
    state.mode = mode;
    var rest = q('[data-nwf-rest]');
    var first = rest.hidden;
    rest.hidden = false;
    if (first) rest.classList.add('nwf__reveal');
    q('[data-nwf-step="order"]').classList.toggle('is-done', mode === 'order');
    renderItems();
    syncFromHelper();
    if (!keepFocus) {
      var step = q('[data-nwf-step="plants"]');
      scrollTo(step);
      var f = step.querySelector('input'); if (f) f.focus({ preventScroll: true });
    }
  }

  // ---------- step 2: plants ----------
  function sizeOf(v) { return String(v || '').split('/')[0].trim(); }
  function renderItems() {
    var list = q('[data-nwf-items]'), man = q('[data-nwf-manualbox]');
    if (state.mode === 'order' && state.order && state.order.line_items.length) {
      man.hidden = true; list.hidden = false;
      var now = Date.now();
      list.innerHTML = state.order.line_items.map(function (l, i) {
        var d = l.delivered_at || l.shipped_at, when = '', late = false;
        if (l.delivered_at) when = 'Delivered ' + fmtDate(l.delivered_at);
        else if (l.shipped_at) when = 'Shipped ' + fmtDate(l.shipped_at);
        else when = 'Not shipped yet';
        if (d && (now - new Date(d).getTime()) > 365 * 864e5) late = true;
        var qty = '';
        if (l.qty > 1) {
          var opts = ''; for (var n = 1; n <= Math.min(l.qty, 100); n++) opts += '<option value="' + n + '"' + (n === l.qty ? ' selected' : '') + '>' + n + '</option>';
          qty = '<span class="nwf__qty"><label for="nwf-q' + i + '">How many</label><select id="nwf-q' + i + '" data-qty>' + opts + '</select></span>';
        } else qty = '<span class="nwf__qty">Qty 1</span>';
        return '<li class="nwf__item" data-line="' + esc(l.line_item_id) + '"><input type="checkbox" id="nwf-li' + i + '" aria-describedby="nwf-li' + i + '-d">'
          + '<label for="nwf-li' + i + '"><b>' + esc(l.title.split(' | ')[0]) + '</b><small id="nwf-li' + i + '-d">' + esc(sizeOf(l.variant)) + (sizeOf(l.variant) ? ' · ' : '') + esc(when) + '</small>'
          + (late ? '<small class="nwf__late">Delivered more than a year ago. The warranty covers 1 year from delivery.</small>' : '') + '</label>' + qty + '</li>';
      }).join('');
      if (state.order.line_items.length === 1) { var cb = list.querySelector('input[type=checkbox]'); cb.checked = true; cb.closest('li').classList.add('is-on'); }
    } else {
      list.innerHTML = ''; list.hidden = true; man.hidden = false;
      if (!qa('[data-nwf-mrows] .nwf__mrow').length) addRow();
    }
  }
  q('[data-nwf-items]').addEventListener('change', function (e) {
    var li = e.target.closest('li'); if (!li) return;
    var cb = li.querySelector('input[type=checkbox]');
    if (e.target.matches('[data-qty]') && !cb.checked) cb.checked = true;
    li.classList.toggle('is-on', cb.checked);
  });
  var rowN = 0;
  function addRow() {
    var i = ++rowN, box = q('[data-nwf-mrows]');
    var d = document.createElement('div'); d.className = 'nwf__mrow';
    d.innerHTML = '<div class="nwf__f"><label for="nwf-mt' + i + '">Plant</label><input id="nwf-mt' + i + '" type="text" maxlength="160" data-mtitle placeholder="e.g. American Hazelnut, 2-3 ft"></div>'
      + '<div class="nwf__f"><label for="nwf-mq' + i + '">How many</label><input id="nwf-mq' + i + '" type="number" min="1" max="500" value="1" inputmode="numeric" data-mqty></div>'
      + '<button type="button" class="nwf__x" aria-label="Remove this plant" data-mdel>&times;</button>';
    box.appendChild(d);
    return d;
  }
  q('[data-nwf-addrow]').addEventListener('click', function () { var r = addRow(); r.querySelector('input').focus(); });
  q('[data-nwf-mrows]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-mdel]'); if (!b) return;
    var rows = qa('[data-nwf-mrows] .nwf__mrow');
    if (rows.length === 1) { rows[0].querySelector('[data-mtitle]').value = ''; rows[0].querySelector('[data-mqty]').value = 1; rows[0].querySelector('input').focus(); return; }
    var row = b.closest('.nwf__mrow'), prev = row.previousElementSibling || row.nextElementSibling;
    row.remove(); if (prev) prev.querySelector('input').focus();
  });
  function collectItems() {
    if (state.mode === 'order' && state.order && state.order.line_items.length) {
      return qa('[data-nwf-items] li').filter(function (li) { return li.querySelector('input[type=checkbox]').checked; }).map(function (li) {
        var s = li.querySelector('[data-qty]');
        return { line_item_id: li.getAttribute('data-line'), qty: s ? parseInt(s.value, 10) : 1 };
      });
    }
    return qa('[data-nwf-mrows] .nwf__mrow').map(function (r) {
      return { title: r.querySelector('[data-mtitle]').value.trim(), qty: parseInt(r.querySelector('[data-mqty]').value, 10) || 1 };
    }).filter(function (x) { return x.title; });
  }

  // ---------- step 3: what happened ----------
  var TIPS = {
    arrived: "Please don't plant it. Add photos of the plant and the box as it arrived. Plants that arrive damaged, dead or wrong are replaced.",
    missing: 'Missing items must be reported within 24 hours of delivery, before planting anything from the box. Add a photo of everything you received.',
    noleaf: 'Did the scratch test show brown all the way down? If you found green, the plant is alive. Keep the soil moist and check again in two weeks.',
    died: "Add a photo of the whole plant. If it was planted in its zone following our planting steps, you'll get store credit for its original price.",
    other: '',
  };
  function whatChanged() {
    var r = q('input[name="what"]:checked'), v = r ? r.value : '';
    q('[data-nwf-tip]').textContent = TIPS[v] || '';
    var lab = q('label[for="nwf-planted"]');
    var needDate = v === 'noleaf' || v === 'died';
    lab.innerHTML = 'Planting date ' + (needDate ? '' : '<span class="nwf__opt">(optional if not planted)</span>');
    setErr('what', '');
  }
  qa('input[name="what"]').forEach(function (r) { r.addEventListener('change', function () { state.whatTouched = true; whatChanged(); }); });

  // ---------- step 4: photos ----------
  var fileInput = q('[data-nwf-file]'), drop = q('[data-nwf-drop]'), thumbs = q('[data-nwf-thumbs]');
  function photoMsg(m, ok) { var e = q('#nwf-photos-e'); e.textContent = m || ''; e.style.color = ok ? 'var(--g,#214525)' : ''; if (m && !ok) fileInput.setAttribute('aria-invalid', 'true'); else fileInput.removeAttribute('aria-invalid'); }
  function totalBytes() { return state.photos.reduce(function (a, p) { return a + p.blob.size; }, 0); }

  function loadImage(file) {
    if (window.createImageBitmap) {
      return createImageBitmap(file, { imageOrientation: 'from-image' }).catch(function () { return createImageBitmap(file); }).catch(function () { return viaImg(file); });
    }
    return viaImg(file);
  }
  function viaImg(file) {
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(file), img = new Image();
      img.onload = function () { URL.revokeObjectURL(u); res(img); };
      img.onerror = function () { URL.revokeObjectURL(u); rej(new Error('decode')); };
      img.src = u;
    });
  }
  function resize(file) {
    return loadImage(file).then(function (img) {
      var w = img.width, h = img.height, max = 1600, s = Math.min(1, max / Math.max(w, h));
      var c = document.createElement('canvas'); c.width = Math.round(w * s); c.height = Math.round(h * s);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      if (img.close) img.close();
      return new Promise(function (res, rej) { c.toBlob(function (b) { b ? res(b) : rej(new Error('encode')); }, 'image/jpeg', 0.82); });
    }).then(function (blob) {
      return { blob: blob, name: file.name.replace(/\.[^.]+$/, '') + '.jpg', type: 'image/jpeg', preview: true };
    }).catch(function () {
      // Could not decode in this browser (often HEIC outside Safari): send the original if it fits.
      if (file.size <= MAX_BYTES) return { blob: file, name: file.name, type: file.type || 'image/heic', preview: false };
      throw new Error('too big');
    });
  }

  function addFiles(list) {
    photoMsg('');
    var files = Array.prototype.slice.call(list || []).filter(function (f) { return /^image\//.test(f.type) || /\.(heic|heif)$/i.test(f.name); });
    if (list && list.length && !files.length) { photoMsg('Those files are not photos. Please choose image files.'); return; }
    var room = MAX_PHOTOS - state.photos.length;
    if (room <= 0) { photoMsg('You already have ' + MAX_PHOTOS + ' photos. Remove one to add another.'); return; }
    if (files.length > room) photoMsg('Only the first ' + room + ' were added (up to ' + MAX_PHOTOS + ' photos).');
    files = files.slice(0, room);
    photoMsg('Preparing ' + files.length + ' photo' + (files.length > 1 ? 's' : '') + '…', true);
    Promise.all(files.map(function (f) { return resize(f).catch(function () { return { error: f.name }; }); })).then(function (out) {
      var skipped = [];
      out.forEach(function (p) {
        if (p.error) { skipped.push(p.error + ' (too large or unreadable)'); return; }
        if (totalBytes() + p.blob.size > BUDGET) { skipped.push(p.name + ' (photos too large together)'); return; }
        p.id = Math.random().toString(36).slice(2);
        p.url = p.preview ? URL.createObjectURL(p.blob) : null;
        state.photos.push(p);
      });
      renderThumbs();
      if (skipped.length) photoMsg('Not added: ' + skipped.join(', ') + '.');
      else photoMsg(state.photos.length + ' of ' + MAX_PHOTOS + ' photos added.', true);
    });
  }
  function renderThumbs() {
    thumbs.innerHTML = state.photos.map(function (p, i) {
      return '<li class="nwf__thumb">' + (p.url ? '<img src="' + p.url + '" alt="Photo ' + (i + 1) + ' preview">' : '<span class="nwf__heic">' + esc(p.name) + '</span>')
        + '<button type="button" data-del="' + p.id + '" aria-label="Remove photo ' + (i + 1) + '">&times;</button></li>';
    }).join('');
  }
  fileInput.addEventListener('change', function () { addFiles(fileInput.files); fileInput.value = ''; });
  thumbs.addEventListener('click', function (e) {
    var b = e.target.closest('[data-del]'); if (!b) return;
    var i = state.photos.findIndex(function (p) { return p.id === b.getAttribute('data-del'); });
    if (i < 0) return;
    if (state.photos[i].url) URL.revokeObjectURL(state.photos[i].url);
    state.photos.splice(i, 1); renderThumbs();
    photoMsg('Photo removed. ' + state.photos.length + ' of ' + MAX_PHOTOS + ' photos.', true);
    fileInput.focus();
  });
  ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.remove('is-over'); }); });
  drop.addEventListener('drop', function (e) { e.preventDefault(); if (e.dataTransfer) addFiles(e.dataTransfer.files); });

  function toDataUrl(blob) {
    return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(r.result); }; r.onerror = rej; r.readAsDataURL(blob); });
  }

  // ---------- submit ----------
  var submitBtn = q('[data-nwf-submit]'), submitStatus = q('[data-nwf-submit-status]');
  function setSubmitStatus(msg, ok) { submitStatus.textContent = msg || ''; submitStatus.className = 'nwf__status' + (msg ? (ok ? ' nwf__status--ok' : ' nwf__status--bad') : ''); }

  function validate(data) {
    var e = {};
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(data.email)) e.email = 'Enter your email (in step 1).';
    if (data.order_number && !/^#?\s*(nrn)?\s*\d{4,7}$/i.test(data.order_number)) e.order_number = 'Order numbers look like NRN12345.';
    if (!data.items.length) e.items = state.mode === 'order' ? 'Tick at least one plant.' : 'Enter at least one plant.';
    if (!data.what) e.what = 'Choose what happened.';
    if ((data.what === 'noleaf' || data.what === 'died') && !data.planting_date) e.planting_date = 'Enter about when you planted it.';
    if (data.planting_date && data.planting_date > q('#nwf-planted').max) e.planting_date = 'The planting date is in the future.';
    if (!/^\d{5}$/.test(data.zip)) e.zip = 'Enter a 5-digit ZIP.';
    if (data.description.length < 10) e.description = 'Tell us a little about what happened.';
    if (!state.photos.length) e.photos = 'Add at least one photo.';
    if (!data.name) e.name = 'Enter your name.';
    if (data.consent !== 'yes') e.consent = 'Please tick the box to confirm.';
    return e;
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (state.busy) return;
    if (!state.mode) { showRest('manual', true); }
    clearErrs(); setSubmitStatus('');
    var w = q('input[name="what"]:checked');
    var data = {
      order_number: q('#nwf-order').value.trim(), email: q('#nwf-email').value.trim(),
      name: q('#nwf-name').value.trim(), phone: q('#nwf-phone').value.trim(),
      zip: q('#nwf-zip').value.trim(), what: w ? w.value : '', planting_date: q('#nwf-planted').value,
      description: q('#nwf-desc').value.trim(), items: collectItems(),
      consent: q('[data-nwf-consent]').checked ? 'yes' : '', consent_text: q('[data-nwf-consent-text]').textContent.trim(),
      website: q('#nwf-website').value,
    };
    var errs = validate(data);
    if (Object.keys(errs).length) { showErrs(errs); track('warranty_claim_invalid', { fields: Object.keys(errs).join(',') }); return; }
    busy(submitBtn, true); setSubmitStatus('Sending your claim and photos…', true);
    Promise.all(state.photos.map(function (p) { return toDataUrl(p.blob).then(function (d) { return { name: p.name, type: p.type, data: d }; }); }))
      .then(function (ph) { data.photos = ph; return post('/claims', data); })
      .then(function (r) {
        busy(submitBtn, false);
        if (r.status === 201 && r.data.id) {
          setSubmitStatus('');
          form.hidden = true;
          var done = q('[data-nwf-done]');
          q('[data-nwf-id]').textContent = r.data.id;
          done.hidden = false; done.focus(); scrollTo(done);
          var old = document.querySelector('.nwf-old'); if (old) old.hidden = true;
          state.photos.forEach(function (p) { if (p.url) URL.revokeObjectURL(p.url); });
          track('warranty_claim', { what: data.what, mode: state.mode, photos: state.photos.length });
          return;
        }
        setSubmitStatus('');
        if (r.status === 400 && r.data.fields) return showErrs(r.data.fields, r.data.error);
        var msg = (r.data && r.data.error) || 'Something went wrong.';
        setSubmitStatus(msg + ' If it keeps happening, use the old form below or email cs@northernridgenursery.com.', false);
        track('warranty_claim_error', { status: r.status });
      })
      .catch(function () { busy(submitBtn, false); setSubmitStatus("We couldn't read one of your photos. Remove it and try again.", false); });
  });

  // ---------- old form fallback (MightyForms embed from the page content, loaded only on request) ----------
  var oldBtn = document.querySelector('[data-nwf-old]');
  if (oldBtn) oldBtn.addEventListener('click', function () {
    var box = document.getElementById('nwf-old-box'), tpl = document.getElementById('nwf-old-tpl');
    if (!box) return;
    if (!box.__filled && tpl) {
      box.__filled = true;
      var frag = tpl.content.cloneNode(true);
      // Scripts cloned from a <template> must be recreated to run.
      Array.prototype.slice.call(frag.querySelectorAll('script')).forEach(function (s) {
        var n = document.createElement('script');
        Array.prototype.slice.call(s.attributes).forEach(function (a) { n.setAttribute(a.name, a.value); });
        n.text = s.text; s.parentNode.replaceChild(n, s);
      });
      box.appendChild(frag);
      track('warranty_old_form', {});
    }
    box.hidden = !box.hidden;
    oldBtn.setAttribute('aria-expanded', box.hidden ? 'false' : 'true');
  });
})();
